'use strict';
var NATIVE_BIND = require('../internals/function-bind-native');

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};



//////////////////
// WEBPACK FOOTER
// /data/websites/bestcompany1982.it/httpdocs/wp-content/themes/g2k-theme-2/node_modules/core-js/internals/function-call.js
// module id = 18
// module chunks = 0